import { createReducer } from '@reduxjs/toolkit';
import {
	UserPortofolioDetailInterface,
	UserPortofolioDetailListInterface,
} from 'app/interfaces/lender/UserPortofolioDetailInterface';
import { ICommonState } from 'app/interfaces/reducer-interface/common.interface';
import { ITableItem } from 'app/interfaces/table-item/table-item.interface';
import {
	getUserPortofolioDetailAction,
	getUserPortofolioListAction,
	setUserPortofolioDetailAction,
	setUserPortofolioListAction,
} from '../actions/UserPortofolioAction';
import { IPagination } from './PortofolioReducer';

export interface UserPortofolioListItem extends ITableItem {
	borrowerName: string;
	borrowerId: string;
	activeLoanAmount: number;
	paidAmount: number;
	totalLoanAmount: number;
}

export interface UserPortofolioListState extends ICommonState {
	userPortofolioList: UserPortofolioListItem[];
	userPortofolioDetail: UserPortofolioDetailInterface;
	pagination: IPagination;
}

const userPortofolioDetailListInit: UserPortofolioDetailListInterface[] = [
	{
		loanNumber: '',
		loanId: '',
		fundingDate: 0,
		loanAmount: 0,
		loanStatus: 0,
		loanStatusName: '',
		textLabel: [],
	},
];

const paginationInit: IPagination = {
	totalData: 0,
	totalPage: 0,
	page: 1,
};

const userPortofolioDetailInit: UserPortofolioDetailInterface = {
	detailList: userPortofolioDetailListInit,
	borrowerId: '',
    pagination: paginationInit
};

const initalState: UserPortofolioListState = {
	loading: false,
	userPortofolioList: [],
	userPortofolioDetail: userPortofolioDetailInit,
	pagination: paginationInit,
	error: '',
	message: '',
};

const userPortofolioReducer = createReducer(initalState, (builder) => {
	builder
		.addCase(getUserPortofolioListAction, (state) => ({
			...state,
			loading: true,
		}))
		.addCase(setUserPortofolioListAction, (state, action) => ({
			...state,
			loading: false,
			userPortofolioList: action.payload.userPortofolioList,
			pagination: action.payload.pagination,
		}))
		.addCase(getUserPortofolioDetailAction, (state) => ({
			...state,
		}))
		.addCase(setUserPortofolioDetailAction, (state, action) => ({
			...state,
			userPortofolioDetail: action.payload,
		}))
		.addDefaultCase((state) => ({
			...state,
		}));
});

export default userPortofolioReducer;
